import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "./OrderNow.scss";

class OrderNow extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClick = () => {
    // Hành động khi nhấn nút
    this.props.history.push("/order/a5"); // có thể đổi thành URL thật hoặc mở modal
  };
  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <>
        <div className="order-button-container" onClick={this.handleClick}>
          <div className="order-button-circle">
            <i className="fas fa-shopping-cart order-icon"></i>
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrderNow)
);
